import React from 'react';
import './sec6.css'

import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect } from 'react';

const Sec6 = () => {
    const [img, setimg]= useState([]);






useEffect(() => {
const getimg = async()=>{
    const res = await supabase.from('images_scroll_repeated_sections').select('*');

setimg(res.data);
}
getimg();
}, []);






    return ( 
        <section className='sec6'>
            <figure className='track-sec6'>
                <figure className='container-sec6'>
                        {/* <img src={pic18} alt=''></img>
                        <img src={pic19} alt=''></img>
                        <img src={pic20} alt=''></img>
                        <img src={pic21} alt=''></img>
                        <img src={pic22} alt=''></img>
                        <img src={pic23} alt=''></img>
                        <img src={pic24} alt=''></img>
                        <img src={pic25} alt=''></img> */}
                      {img?.map((item, i) => (
                        <img key={i} src={item.img} alt={item.alt}  />
                        ))}
                </figure>
                <figure className='container-sec6'>
                      {img?.map((item, i) => (
                        <img key={i} src={item.img} alt={item.alt} />
                        ))}
                </figure>
            </figure>


            <figure className='track-reverse'>
                <figure className='container-sec6'>
                        {/* <img src={pic18} alt=''></img>
                        <img src={pic19} alt=''></img>
                        <img src={pic20} alt=''></img>
                        <img src={pic21} alt=''></img>
                        <img src={pic22} alt=''></img>
                        <img src={pic23} alt=''></img>
                        <img src={pic24} alt=''></img>
                        <img src={pic25} alt=''></img> */}
                      {img?.map((item, i) => (
                        <img key={i} src={item.img} alt={item.alt}  />
                        ))}
                </figure>
                            <figure className='container-sec6'>
                      {img?.map((item, i) => (
                        <img key={i} src={item.img} alt={item.alt}  />
                        ))}
                </figure>

             </figure>   

        </section>
     );
}
 
export default Sec6;